export default __webpack_public_path__ + "static/media/GTWalsheimPro-Regular.1668df1c.woff";